import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import homeDataHeader from "./components/home-data-header/home-data-header.vue";
import homeDataMap from "./components/home-data-map/home-data-map.vue";
import homeStatisticsMini from "./components/home-statistics-mini/home-statistics-mini.vue";
import homeStatisticsSamll from "./components/home-statistics-small/home-statistics-small.vue";
import homeDataLinePie from "./components/home-data-line-pie/home-data-line-pie.vue";
import homeDataAnnular from "./components/home-data-annular/home-data-annular.vue";
import homeDataBottom from "./components/home-data-bottom/home-data-bottom.vue";
import homeDataTimeRanking from "./components/home-data-ranking/home-data-ranking.vue";
import { echartsJS } from "@/common/add-js";
import { State } from "vuex-class";
import { getBigAggregateData } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import { hTimer } from "@/common/timer.helper";
import { DateType, MapType } from "./home-screen.enum";
let PiHomeData = class PiHomeData extends Vue {
    constructor() {
        super(...arguments);
        this.oprPkId = "";
        this.statisticsData = {
            1: {},
            2: {},
            3: {},
        };
        this.isEchart = false;
        this.statisticsMiniList = [
            {
                name: i18n.t("homeData.totalMoney"),
                valueKey: "totalRevenueAmount",
                className: "",
            },
            {
                name: i18n.t("homeData.totalDlMoney"),
                valueKey: "totalElecAmount",
                className: "type-2",
            },
            {
                name: i18n.t("homeData.totalServerMoney"),
                valueKey: "totalSeviceAmount",
                className: "type-3",
            },
        ];
        this.statisticsSmallList = [
            {
                name: i18n.t("homeData.totalOrder"),
                valueKey: "totalChargingTimes",
                unit: i18n.t("homeData.orderUnit"),
                className: "",
            },
            {
                name: i18n.t("homeData.totalDl"),
                valueKey: "totalChargeElect",
                unit: "kWh",
                className: "type-2",
            },
            {
                name: i18n.t("homeData.totalUser"),
                valueKey: "activeNumber",
                unit: i18n.t("unitText.people"),
                className: "mgtop",
            },
            {
                name: i18n.t("homeData.totalChargingTime"),
                valueKey: "totalChargingSeconds",
                unit: i18n.t("unitText.xHours"),
                className: "type-2 mgtop",
            },
        ];
        /**
         * 轮循定时器
         */
        this.timer = {};
        /**
         * 正在轮循显示的统计   累計、今日、昨日
         */
        this.dateType = DateType.Type1;
        /**
         * 正在显示的地图
         */
        this.mapType = MapType.Type1;
    }
    async echartInit() {
        await echartsJS();
        this.isEchart = true;
    }
    operChange(val) {
        this.oprPkId = val;
        this.statisticsData = {
            1: {},
            2: {},
            3: {},
        };
        this.dateType = DateType.Type1;
        this.mapType = MapType.Type1;
        this.getBigAggregateData(1);
    }
    async getBigAggregateData(totalType, callBack) {
        if (Object.keys(this.statisticsData[totalType]).length == 0) {
            const ret = await getBigAggregateData({
                oprPkId: this.oprPkId,
                dateType: totalType,
            });
            if (ret.status === this.$config.apiStatus) {
                let data = ret.data[0] || {};
                this.statisticsData[totalType] = data;
            }
            callBack && callBack();
        }
    }
    /**
     * 组件里点击 累計、今日、昨日,  取消定时器再打开
     */
    statisticsChange(type) {
        this.timerEnd();
        this.getBigAggregateData(type, () => {
            this.timerStart();
        });
    }
    /**
     * 开启定时器，30秒请求一下统计数据
     */
    timerStart() {
        this.timer = hTimer(() => {
            this.dateType++;
            this.mapType++;
            if (this.dateType > 3) {
                this.dateType = DateType.Type1;
            }
            if (this.mapType > 2) {
                this.mapType = MapType.Type1;
            }
            this.getBigAggregateData(this.dateType);
        }, 30 * 1000);
    }
    /**
     * 关闭定时器
     */
    timerEnd() {
        this.timer.close && this.timer.close();
    }
    activated() {
        this.timerStart();
    }
    deactivated() {
        // 切换页面要关掉它
        this.timerEnd();
    }
    mounted() {
        this.getBigAggregateData(1);
        this.$nextTick(() => {
            this.echartInit();
        });
    }
    created() {
        this.oprPkId = this.sys.operInfo.oprPkId || "";
    }
};
__decorate([
    State("sys")
], PiHomeData.prototype, "sys", void 0);
PiHomeData = __decorate([
    Component({
        components: {
            "pi-home-data-header": homeDataHeader,
            "pi-home-data-map": homeDataMap,
            "pi-home-statistics-mini": homeStatisticsMini,
            "pi-home-statistics-small": homeStatisticsSamll,
            "pi-home-data-line-pie": homeDataLinePie,
            "pi-home-data-annular": homeDataAnnular,
            "pi-home-data-bottom": homeDataBottom,
            "pi-home-data-time-ranking": homeDataTimeRanking,
        },
    })
], PiHomeData);
export default PiHomeData;
